<div class="content-info ap-page">
  <!-- Header: breadcrumb, title + SKU chip, actions, step pills (sticky) -->
  <div class="zf-doc-head ap-head">
    <div class="zf-doc-left">
      <div class="ap-crumbs">
        <a href="#/product-list">Products</a>
        <span class="sep">/</span>
        <span class="cur">{{ isEdit ? 'Edit' : 'New' }}</span>
      </div>
      <div class="zf-doc-title-row">
        <h3 class="zf-doc-title">{{ title }}</h3>
        <span class="ap-sku-chip">{{ val('sku') ? 'SKU ' + val('sku') : 'SKU auto' }}</span>
      </div>
    </div>

    <div class="zf-doc-actions">
      <button type="button" class="ap-btn ap-btn-cancel" (click)="goBack()">Cancel</button>
      <button type="button" class="ap-btn ap-btn-soft" (click)="clearForm()">Clear</button>
      <button type="button" class="ap-btn ap-btn-line" [disabled]="currentStep === 1" (click)="prevStep()">Back</button>
      <button type="button" class="ap-btn ap-btn-primary" (click)="nextStep()">
        {{ currentStep < 3 ? 'Next' : (isEdit ? 'Save changes' : 'Submit product') }}
      </button>
    </div>

    <div class="ap-steps">
      @for (s of steps; track s.n) {
      <button type="button" class="ap-step" [class.on]="s.n === currentStep" [class.done]="s.n < currentStep"
        (click)="goToStep(s.n)">
        <span class="num">{{ s.n < currentStep ? '✓' : s.n }}</span>{{ s.label }}
      </button>
      }
    </div>
  </div>

  <div class="ap-layout">
    <section class="ap-main">
      <form [formGroup]="productForm" class="ap-stack" autocomplete="off">

        <!-- ═══════════════════════ Step 1 · Basic info ═══════════════════════ -->
        @if (currentStep === 1) {

        <!-- 01 Item info -->
        <div class="ap-card">
          <div class="ap-card-head">
            <span class="ap-no">01</span>
            <h2>Item info</h2>
            <span class="ap-head-note">Long description is the product name shown and searched everywhere</span>
          </div>
          <div class="ap-card-body ap-grid g4">
            <!-- Long description is the product's display name: every list,
                 search box and invoice shows it, and product search matches on
                 it (DB varchar 150) — so it is a single line, first and widest. -->
            <div class="ap-field span2">
              <span class="ap-label">Long description <span class="meta">· product name</span> <span class="req">*</span>
                <span class="count" [class.full]="(val('longDescription') || '').length >= 150">{{ (val('longDescription') || '').length }}/150</span></span>
              <input type="text" class="form-control" formControlName="longDescription" maxlength="150"
                placeholder="e.g. Aquasonic Ultrasound Transmission Gel 250ml Bottle" />
              @if (bad('longDescription')) { <div class="ap-err">Long description is required</div> }
            </div>
            <div class="ap-field">
              <span class="ap-label">Short description <span class="req">*</span>
                <span class="count" [class.full]="(val('shortDescription') || '').length >= 30">{{ (val('shortDescription') || '').length }}/30</span></span>
              <input type="text" class="form-control" formControlName="shortDescription" maxlength="30"
                placeholder="e.g. US gel 250ml" />
              @if (bad('shortDescription')) { <div class="ap-err">Short description is required</div> }
            </div>
            <div class="ap-field">
              <span class="ap-label">Vendor @if (masterRequired.vendor) { <span class="req">*</span> }</span>
              <ng-select [items]="vendors" bindLabel="name" bindValue="id" [searchable]="true" [clearable]="true"
                placeholder="Search vendor" formControlName="vendorsId">
              </ng-select>
              @if (bad('vendorsId')) { <div class="ap-err">Vendor is required</div> }
            </div>

            <div class="ap-field">
              <span class="ap-label">Manufacturer @if (masterRequired.manufacturer) { <span class="req">*</span> }</span>
              <ng-select [items]="manufacturers" bindLabel="name" bindValue="id" [searchable]="true"
                [clearable]="true" [addTag]="addManufacturerTag" addTagText="+ Add"
                (change)="onManufacturerSelect($event)" placeholder="Search or add"
                formControlName="manufacturerId">
              </ng-select>
              @if (bad('manufacturerId')) { <div class="ap-err">Manufacturer is required</div> }
            </div>
            <div class="ap-field">
              <span class="ap-label">Brand @if (masterRequired.brand) { <span class="req">*</span> }</span>
              <ng-select [items]="brandOptions" bindLabel="name" bindValue="id" [searchable]="true"
                [searchFn]="brandSearch" [clearable]="true" [addTag]="addBrandTag" addTagText="+ Add"
                [placeholder]="brandLinked && !val('manufacturerId') ? 'Search, or pick a manufacturer to add' : 'Search or add'"
                notFoundText="No brand found" (change)="onBrandSelect($event)" formControlName="brandId">
                <ng-template ng-option-tmp let-item="item">
                  {{ item.name }}@if (item.manufacturer?.name) {<span class="ap-opt-sub"> · {{ item.manufacturer.name }}</span>}
                </ng-template>
              </ng-select>
              @if (bad('brandId')) { <div class="ap-err">Brand is required</div> }
            </div>
            <div class="ap-field span2">
              <span class="ap-label">Product image
                @if (val('photoUrl')) {
                <button type="button" class="ap-link danger ms-auto" (click)="removeImage()">Remove</button>
                }
              </span>
              <div class="ap-image-drop" [class.drag]="imageDragOver" [class.busy]="imageUploading"
                (dragover)="$event.preventDefault(); imageDragOver = true" (dragleave)="imageDragOver = false"
                (drop)="onImageDrop($event)">
                @if (val('photoUrl')) {
                <img [src]="val('photoUrl')" alt="" class="thumb" (error)="imageBroken = true" (load)="imageBroken = false" />
                } @else {
                <span class="shot">PRODUCT SHOT</span>
                }
                <div class="ap-image-actions">
                  @if (imageUploading) {
                  <span class="ap-image-status"><span class="spinner-border spinner-border-sm"></span> Uploading…</span>
                  } @else {
                  <button type="button" class="ap-link" (click)="imageInput.click()">
                    {{ val('photoUrl') ? 'Replace image' : 'Choose file' }}
                  </button>
                  <span class="ap-image-meta">or drop here · PNG, JPG, WEBP · max 5 MB</span>
                  }
                </div>
                <input #imageInput type="file" accept="image/png,image/jpeg,image/webp,image/gif" hidden
                  (change)="onImagePicked(imageInput)" />
              </div>
              <input type="text" class="ap-image-url" formControlName="photoUrl"
                placeholder="…or paste an image URL" />
              @if (val('photoUrl') && imageBroken) { <div class="ap-err">That image can't be loaded — check the URL</div> }
            </div>
          </div>
        </div>

        <!-- 02 Category information -->
        <div class="ap-card">
          <div class="ap-card-head">
            <span class="ap-no">02</span>
            <h2>Category information</h2>
            <span class="ap-head-note">{{ categoryPath }}</span>
          </div>
          <div class="ap-card-body ap-grid g4">
            <div class="ap-field">
              <span class="ap-label">Department <span class="req">*</span></span>
              <ng-select [items]="departments" bindLabel="name" bindValue="id" [searchable]="true"
                [clearable]="true" [addTag]="addDepartmentTag" addTagText="+ Add" placeholder="Search or add"
                formControlName="departmentId">
              </ng-select>
              @if (bad('departmentId')) { <div class="ap-err">Department is required</div> }
            </div>
            <div class="ap-field">
              <span class="ap-label">Category <span class="req">*</span></span>
              <ng-select [items]="categories" bindLabel="name" bindValue="id" [searchable]="true"
                [clearable]="true" [addTag]="val('departmentId') ? addCategoryTag : false" addTagText="+ Add"
                [placeholder]="val('departmentId') ? 'Search or add' : 'Select a department first'"
                notFoundText="Select a department first" formControlName="categoryId">
              </ng-select>
              @if (bad('categoryId')) { <div class="ap-err">Category is required</div> }
            </div>
            <div class="ap-field">
              <span class="ap-label">Sub category</span>
              <ng-select [items]="subCategories" bindLabel="name" bindValue="id" [searchable]="true"
                [clearable]="true" [addTag]="val('categoryId') ? addSubCategoryTag : false" addTagText="+ Add"
                [placeholder]="val('categoryId') ? 'Search or add' : 'Select a category first'"
                notFoundText="Select a category first" formControlName="subCategoryId">
              </ng-select>
            </div>
            <div class="ap-field">
              <span class="ap-label">SKU code <span class="ap-mode-chip">AUTO</span></span>
              <input type="text" class="form-control ap-mono ap-readonly" formControlName="sku" [readonly]="true"
                placeholder="Generated from dept · cat · sub cat" />
              @if (bad('sku')) { <div class="ap-err">Pick department, category and sub category to generate the SKU</div> }
            </div>
          </div>
        </div>

        <!-- 03 Item properties -->
        <div class="ap-card">
          <div class="ap-card-head">
            <span class="ap-no">03</span>
            <h2>Item properties</h2>
            <span class="ap-head-note">Drives expiry, batch and putaway rules</span>
          </div>
          <div class="ap-card-body ap-stack">
            <div class="ap-grid g3 tight">
              @for (sw of propertySwitches; track sw.key) {
              <label class="ap-switch" [class.on]="!!val(sw.key)">
                <input type="checkbox" [formControlName]="sw.key" />
                <span class="lbl">{{ sw.label }}</span>
                <span class="track"><span class="knob"></span></span>
              </label>
              }
            </div>
            <div class="ap-grid g4 ap-divide">
              <div class="ap-field">
                <span class="ap-label">Shelf life (days)</span>
                <input type="number" class="form-control ap-mono" formControlName="shelfLifeDays" placeholder="0" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Minimum shelf life (days)</span>
                <input type="number" class="form-control ap-mono" formControlName="minShelfLifeDays" placeholder="0" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Minimum shelf life (%)</span>
                <div class="zf-affix">
                  <input type="number" formControlName="minShelfLifePercent" placeholder="0" />
                  <span class="zf-affix-k">%</span>
                </div>
              </div>
              <div class="ap-field">
                <span class="ap-label">Shelf life rule</span>
                <span class="ap-hint" [class.warn]="shelfHint.warn">{{ shelfHint.text }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 04 Tax info · 05 Packing -->
        <div class="ap-pair">
          <div class="ap-card">
            <div class="ap-card-head">
              <span class="ap-no">04</span>
              <h2>Tax info</h2>
            </div>
            <div class="ap-card-body ap-grid g2">
              <div class="ap-field">
                <span class="ap-label">HSN code <span class="req">*</span></span>
                <input type="text" class="form-control ap-mono" formControlName="hsnCode" placeholder="30049099" />
                @if (bad('hsnCode')) {
                <div class="ap-err">
                  @if (productForm.get('hsnCode')?.errors?.['required']) { HSN code is required }
                  @else if (productForm.get('hsnCode')?.errors?.['hsnNotNumeric']) { HSN code must contain digits only }
                  @else if (productForm.get('hsnCode')?.errors?.['hsnMissingDigit']) {
                  <!-- Odd length is almost always a spreadsheet eating a leading zero. -->
                  HSN code has {{ productForm.get('hsnCode')?.errors?.['hsnMissingDigit'].length }} digits — one is
                  missing. Codes are 4, 6 or 8 digits.
                  }
                  @else if (productForm.get('hsnCode')?.errors?.['hsnLength']) { HSN code must be 4, 6 or 8 digits }
                </div>
                }
                <!-- Live check against the HSN master: HSN has no checksum, so
                     "12345678" passes every format rule. -->
                @if (hsnChecking) {
                <div class="ap-note">Checking HSN…</div>
                } @else if (hsnCheck && hsnCheck.master) {
                <div class="ap-note ok">✓ {{ hsnCheck.master.description }}</div>
                } @else if (hsnCheck && hsnCheck.exists === false) {
                <div class="ap-note warn">
                  Not in the HSN master — check it on the
                  <a href="https://services.gst.gov.in/services/searchhsnsac" target="_blank" rel="noopener">GST
                    portal</a> before saving.
                </div>
                } @else if (hsnCheck && hsnCheck.suggestion) {
                <div class="ap-note warn">Did you mean {{ hsnCheck.suggestion }}?</div>
                }
              </div>
              <div class="ap-field">
                <span class="ap-label">Cess</span>
                <label class="ap-switch" [class.on]="!!val('cessApplicable')">
                  <input type="checkbox" formControlName="cessApplicable" />
                  <span class="lbl">{{ val('cessApplicable') ? 'Applicable' : 'Not applicable' }}</span>
                  <span class="track"><span class="knob"></span></span>
                </label>
              </div>
              <div class="ap-field">
                <span class="ap-label">Purchase GST slab <span class="req">*</span></span>
                <ng-select [items]="gstSlabs" bindLabel="displayLabel" bindValue="id" [searchable]="false"
                  [clearable]="false" placeholder="Select slab" formControlName="purchaseGstRateId">
                </ng-select>
                @if (bad('purchaseGstRateId')) { <div class="ap-err">Purchase GST slab is required</div> }
              </div>
              <div class="ap-field">
                <span class="ap-label">Margin</span>
                <div class="zf-affix">
                  <input type="number" formControlName="marginPercentage" placeholder="0" />
                  <span class="zf-affix-k">%</span>
                </div>
              </div>
              @if (val('cessApplicable')) {
              <div class="ap-field">
                <span class="ap-label">Cess rate</span>
                <div class="zf-affix">
                  <input type="number" formControlName="cessRate" placeholder="0" />
                  <span class="zf-affix-k">%</span>
                </div>
              </div>
              }
            </div>
          </div>

          <div class="ap-card">
            <div class="ap-card-head">
              <span class="ap-no">05</span>
              <h2>Packing</h2>
            </div>
            <div class="ap-card-body ap-grid g2">
              <div class="ap-field">
                <span class="ap-label">UOM <span class="req">*</span></span>
                <ng-select [items]="units" [searchable]="false" [clearable]="false" placeholder="Select UOM"
                  formControlName="uom">
                </ng-select>
                @if (bad('uom')) { <div class="ap-err">UOM is required</div> }
              </div>
              <div class="ap-field">
                <span class="ap-label">Product payment terms (days)</span>
                <input type="number" class="form-control ap-mono" formControlName="productSpecificPaymentTerms"
                  placeholder="0" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Inner packaging</span>
                <input type="number" class="form-control ap-mono" formControlName="innerPackaging"
                  placeholder="e.g. 10" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Outer packaging</span>
                <input type="number" class="form-control ap-mono" formControlName="outerPackaging"
                  placeholder="e.g. 24" />
              </div>
              @if (val('isWeighable')) {
              <div class="ap-field span2">
                <span class="ap-hint">Sold by weight — quantity is the weighed amount and selling price is per
                  {{ val('uom') || 'kg' }}. Set the scale PLU on each pricing row.</span>
              </div>
              }
            </div>
          </div>
        </div>

        <!-- 06 Bulk product mapping -->
        <div class="ap-card">
          <div class="ap-card-head">
            <span class="ap-no">06</span>
            <h2>Bulk product mapping</h2>
            <span class="ap-head-note">{{ isBulk ? 'This SKU is the bulk parent — child packs map to it' : 'Tag this pack to the bulk parent SKU it breaks down from' }}</span>
          </div>
          <div class="ap-card-body ap-grid g4">
            <div class="ap-field">
              <span class="ap-label">Is bulk?</span>
              <label class="ap-switch" [class.on]="!!isBulk">
                <input type="checkbox" [checked]="isBulk" #isBulkCheckbox
                  (change)="onIsBulkChange(isBulkCheckbox.checked)" />
                <span class="lbl">{{ isBulk ? 'Bulk parent SKU' : 'Regular SKU' }}</span>
                <span class="track"><span class="knob"></span></span>
              </label>
            </div>
            <div class="ap-field">
              <span class="ap-label">Show bulk products?</span>
              <label class="ap-switch" [class.on]="showBulkProductsDetails">
                <input type="checkbox" [checked]="showBulkProductsDetails" #showBulkCheckbox
                  (change)="onShowBulkProductsDetailsChange(showBulkCheckbox.checked)" />
                <span class="lbl">{{ showBulkProductsDetails ? 'Mapped to a parent' : 'Not mapped' }}</span>
                <span class="track"><span class="knob"></span></span>
              </label>
            </div>
            @if (showBulkProductsDetails) {
            <div class="ap-field">
              <span class="ap-label">Parent bulk SKU</span>
              <ng-select [items]="parentProducts" bindLabel="sku" bindValue="id" [searchable]="true"
                [typeahead]="parentProductSearch$" [loading]="isLoadingParentProducts" [clearable]="true"
                placeholder="Search by SKU code" formControlName="bulkParentProductId"
                (change)="onParentProductSelect($event)">
              </ng-select>
            </div>
            <div class="ap-field">
              <span class="ap-label">Or search product name</span>
              <ng-select [items]="parentProductsByName" bindLabel="shortDescription" bindValue="id"
                [searchable]="true" [typeahead]="parentProductNameSearch$" [clearable]="true"
                [loading]="isLoadingParentProductsByName" placeholder="Search by product name"
                formControlName="bulkParentProductId" (change)="onParentProductNameSelect($event)">
              </ng-select>
            </div>
            }
          </div>
          <div class="ap-card-foot">
            <div class="ap-callout" [class.on]="bulkNote.on">{{ bulkNote.text }}</div>
          </div>
        </div>
        }

        <!-- ═══════════════════════ Step 2 · Variants ═══════════════════════ -->
        @if (currentStep === 2) {
        <div formArrayName="variants" class="ap-stack">
          @for (variant of variants.controls; track variant; let i = $index) {
          <div class="ap-card" [formGroupName]="i">
            <div class="ap-card-head">
              <span class="ap-no">V{{ i + 1 }}</span>
              <h2>{{ variant.get('variantName')?.value || 'Variant ' + (i + 1) }}</h2>
              <span class="ap-head-note left">{{ variantSummary(i) }}</span>
              <div class="ap-head-actions">
                <button type="button" class="ap-btn-sm" (click)="cloneVariant(i)">
                  <i class="bi bi-copy"></i> Clone
                </button>
                <button type="button" class="ap-btn-sm danger" [disabled]="variants.length <= 1"
                  (click)="removeVariant(i)">Remove variant</button>
              </div>
            </div>

            <div class="ap-card-body ap-grid ap-vgrid">
              <div class="ap-field">
                <span class="ap-label">Variant name
                  <span class="count">{{ (variant.get('variantName')?.value || '').length }}</span></span>
                <input type="text" class="form-control" formControlName="variantName" placeholder="e.g. Red, Large" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Color</span>
                <input type="text" class="form-control" formControlName="color" placeholder="e.g. Red" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Size</span>
                <input type="text" class="form-control" formControlName="size" placeholder="e.g. XL" />
              </div>
              <div class="ap-field">
                <span class="ap-label">Weight</span>
                <div class="zf-affix">
                  <input type="number" formControlName="weight" placeholder="0.00" class="text-end" />
                  <span class="zf-affix-k">kg</span>
                </div>
              </div>
            </div>

            <div class="ap-vbar">
              <label class="ap-mini-switch" [class.on]="variant.get('isActive')?.value !== false">
                <input type="checkbox" formControlName="isActive" />
                <span class="track"><span class="knob"></span></span>
                <span class="lbl">Active variant</span>
              </label>
              <span class="ap-vsep"></span>
              <span class="ap-muted">Margin {{ val('marginPercentage') || 0 }}% — set in Tax info; it fills cost
                &amp; MRP as you type</span>
            </div>

            <!-- Barcodes: identity, independent of pricing. Only for a saved
                 variant; a new product tags its codes on the pricing row. -->
            @if (isEdit) {
            <div class="ap-card-foot">
              <app-variant-barcodes-panel [variantId]="variant.get('id')?.value ?? null"
                [sku]="productForm.get('sku')?.value ?? null"></app-variant-barcodes-panel>
            </div>
            }

            <!-- Pricing. The EAN is authored per pricing row: a reprinted pack
                 usually carries a new EAN AND a new MRP, so the code belongs to
                 the price it sells at. -->
            <div class="ap-pricing" formArrayName="pricing">
              <div class="ap-pricing-head">
                <span class="t">Pricing configurations</span>
                <span class="ap-count-chip">{{ getPricingControls(i).length }}</span>
                <button type="button" class="ap-btn-sm" (click)="addPricing(i)">＋ Add pricing</button>
              </div>
              <div class="ap-pricing-scroll">
                <div class="ap-prow ap-prow-head">
                  <div>EAN / barcode</div>
                  <div class="r">Base price *</div>
                  <div class="r">Cost price *</div>
                  <div class="r">Selling price *</div>
                  <div class="r">MRP *</div>
                  <div class="r">Wholesale</div>
                  <div>PLU</div>
                  <div title="When this price was last saved">Last updated</div>
                  <div></div>
                </div>
                @for (price of getPricingControls(i).controls; track price; let j = $index) {
                <div class="ap-prow" [formGroupName]="j">
                  <div><input type="text" class="ap-cell ap-mono" formControlName="eanCode" maxlength="20"
                      placeholder="EAN or SKU"
                      title="Code printed on the packs sold at this price. It is also tagged as a barcode of the SKU. Leave blank to keep the current barcode." />
                  </div>
                  <div><input type="number" step="0.0001" class="ap-cell num" formControlName="basePrice"
                      placeholder="0.00" [class.bad]="price.errors?.['basePriceInvalid']"
                      (input)="calculatePricing(i, j, 'base')" /></div>
                  <div><input type="number" step="0.0001" class="ap-cell num" formControlName="costPrice"
                      placeholder="0.00" (input)="calculatePricing(i, j, 'cost')" /></div>
                  <div><input type="number" class="ap-cell num" formControlName="sellingPrice" placeholder="0.00"
                      [class.bad]="price.errors?.['sellingPriceInvalid']" /></div>
                  <div><input type="number" class="ap-cell num" formControlName="mrp" placeholder="0.00"
                      [class.bad]="price.errors?.['mrpInvalid']" (input)="calculatePricing(i, j, 'mrp')" /></div>
                  <div><input type="number" step="0.01" class="ap-cell num" formControlName="wholesalePrice"
                      placeholder="0.00"
                      title="Tax-exclusive rate offered to B2B customers without a price of their own. Leave blank to sell B2B at the selling price." />
                  </div>
                  <div><input type="text" class="ap-cell ap-mono" formControlName="pluCode" placeholder="Scale PLU" />
                  </div>
                  <div class="ap-lud">
                    @if (pricingUpdatedAt(price); as lud) {
                    <span class="ap-mono">{{ lud | date: 'dd-MMM-yyyy' }}</span>
                    <span class="ap-mono muted">{{ lud | date: 'hh:mm a' }}</span>
                    } @else {
                    <span class="muted">New</span>
                    }
                  </div>
                  <div class="c">
                    @if (isOnlyActivePrice(i, price)) {
                    <button type="button" class="ap-trash" disabled
                      title="Only active price of this item — add the new price and save first, then delete this one">
                      <i class="bi bi-trash3"></i></button>
                    } @else {
                    <button type="button" class="ap-trash"
                      [title]="price.value.id ? 'Delete this price (immediately)' : 'Remove this new row'"
                      (click)="removePricing(i, j)"><i class="bi bi-trash3"></i></button>
                    }
                  </div>
                  @if (price.errors?.['basePriceInvalid'] || price.errors?.['mrpInvalid'] ||
                  price.errors?.['sellingPriceInvalid']) {
                  <div class="ap-prow-msg err">
                    {{ price.errors?.['basePriceInvalid'] || price.errors?.['mrpInvalid'] ||
                    price.errors?.['sellingPriceInvalid'] }}
                  </div>
                  } @else if (isZeroMargin(price)) {
                  <div class="ap-prow-msg warn">Zero margin — sells at cost.</div>
                  }
                </div>
                }
              </div>
            </div>
          </div>
          }
          <div>
            <button type="button" class="ap-add-variant" (click)="addVariant()">＋ Add variant</button>
          </div>
        </div>
        }

        <!-- ═══════════════════════ Step 3 · Review & submit ═══════════════════════ -->
        @if (currentStep === 3) {
        <div class="ap-card">
          <div class="ap-card-head">
            <h2>Review &amp; submit</h2>
            <span class="ap-head-note">{{ checks[5].ok ? 'All required pricing is filled' : 'Some required prices are still empty' }}</span>
          </div>
          <div class="ap-card-body ap-grid g4 tight">
            @for (r of reviewTiles; track r.label) {
            <div class="ap-tile">
              <span class="k">{{ r.label }}</span>
              <span class="v" [class.ap-mono]="r.mono">{{ r.value }}</span>
            </div>
            }
          </div>
        </div>

        <div class="ap-card">
          <div class="ap-card-head">
            <h2>Variants &amp; pricing</h2>
            <span class="ap-head-note">{{ variants.length }} variant{{ variants.length === 1 ? '' : 's' }} ·
              {{ pricingRowCount }} pricing row{{ pricingRowCount === 1 ? '' : 's' }}</span>
          </div>
          <div class="ap-pricing-scroll">
            <div class="ap-rrow ap-rrow-head">
              <div>Variant</div>
              <div>Status</div>
              <div>EAN</div>
              <div class="r">Cost</div>
              <div class="r">Selling</div>
              <div class="r">MRP</div>
              <div class="r">Wholesale</div>
              <div class="r">Margin</div>
            </div>
            @for (r of reviewRows; track $index) {
            <div class="ap-rrow">
              <div class="name"><span>{{ r.name }}</span>@if (r.spec) {<small>{{ r.spec }}</small>}</div>
              <div><span class="ap-status" [class.on]="r.active">{{ r.active ? 'Active' : 'Inactive' }}</span></div>
              <div class="ap-mono muted">{{ r.ean }}</div>
              <div class="r ap-mono">{{ r.cost }}</div>
              <div class="r ap-mono strong">{{ r.sell }}</div>
              <div class="r ap-mono muted">{{ r.mrp }}</div>
              @if (r.wholesale) {
              <div class="r ap-mono strong">{{ r.wholesale }}</div>
              } @else {
              <div class="r muted" title="No wholesale price — B2B orders use the selling price">Uses selling</div>
              }
              <div class="r ap-mono strong" [class.pos]="r.margin !== null && r.margin >= 0"
                [class.neg]="r.margin !== null && r.margin < 0">
                {{ r.margin === null ? '—' : (r.margin | number: '1.1-1') + '%' }}
              </div>
            </div>
            } @empty {
            <div class="ap-empty">No pricing rows yet — add them on the Variants step.</div>
            }
          </div>
        </div>
        }
      </form>
    </section>

    <!-- Side panel: readiness, preview, hint -->
    <aside class="ap-aside">
      <div class="ap-card">
        <div class="ap-card-head sm">
          <span class="t">Ready to submit</span>
          <span class="ap-pct">{{ readyPct }}%</span>
        </div>
        <div class="ap-card-body ap-checks">
          <div class="ap-bar"><span [style.width.%]="readyPct"></span></div>
          @for (c of checks; track c.label) {
          <div class="ap-check" [class.ok]="c.ok">
            <span class="dot">{{ c.ok ? '✓' : '' }}</span>
            <span class="l">{{ c.label }}</span>
            <span class="tag">{{ c.tag }}</span>
          </div>
          }
        </div>
      </div>

      <div class="ap-card">
        <div class="ap-card-head sm"><span class="t">Preview</span></div>
        <div class="ap-card-body ap-preview">
          <div class="img">
            @if (val('photoUrl')) { <img [src]="val('photoUrl')" alt="" /> }
            @else { <span>PRODUCT SHOT</span> }
          </div>
          <div class="nm">
            <span class="n">{{ val('longDescription') || val('shortDescription') || 'New product' }}</span>
            <span class="s">SKU {{ val('sku') || '—' }}</span>
          </div>
          <div class="ft">
            <span class="b">{{ previewBrand }}</span>
            <span class="p">{{ previewPrice }}</span>
          </div>
        </div>
      </div>

      <div class="ap-side-hint">
        <span class="i">!</span>
        <span>{{ sideHint }}</span>
      </div>
    </aside>
  </div>
</div>
